import request from '@/utils/request'

// 未完成任务列表
export function todoList(params) {
  return request({ url: '/webapi/order/todoList', method: 'get', params })
}

// 已完成任务列表
export function paidList(params) {
  return request({ url: '/webapi/order/paidList', method: 'get', params })
}

// 已完成任务列表导出
export function billDownload(data) {
  return request({ url: '/webapi/capital/billDownload', method: 'post', data, responseType: 'blob' })
}

// 支付对账
export function payCheck(params) {
  return request({ url: '/webapi/pay/payCheck', method: 'get', params })
}

// 获取返现列表
export function getCashbackList(params) {
  return request({ url: '/webapi/cashback/getCashbackList', method: 'get', params })
}

// 获取返现详情
export function getCashbackDetail(params) {
  return request({ url: '/webapi/cashback/getCashbackDetail', method: 'get', params })
}

// 用工方确认返现
export function confirmCashback(data) {
  return request({ url: '/webapi/cashback/confirmCashback', method: 'post', data })
}

// 用工方拒绝返现
export function rejectCashback(data) {
  return request({ url: '/webapi/cashback/rejectCashback', method: 'post', data })
}

// 扣税详情
export function taxDetail(params) {
  return request({ url: '/webapi/order/taxDetail', method: 'get', params })
}
